export default __webpack_public_path__ + "static/media/ilagan.1c6fb54b.jpg";